<template>
  <div class="bg-white borderd">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <div class="block px-10 py-2 mx-auto mt-0 mb-20">
        <div class="flex">
          <div class="w-1/3 space-y-4">
            <div>
              <ValidationProvider v-slot="{ errors }" name="Namn" rules="required">
                <span class="form-label">Namn</span>
                <input v-model="current.name" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Visningsnamn" rules="required">
                <span class="form-label">Visningsnamn</span>
                <input v-model="current.displayName" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider v-slot="{ errors }" name="Beskrivning" rules="max:250">
                <span class="form-label">Beskrivning</span>
                <textarea rows="4" v-model="current.description" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider name="Aktiv">
                <label class="inline-flex items-center mt-5">
                  <input type="checkbox" class="form-checkbox" v-model="current.enabled" />
                  <span class="form-label ml-2">Aktiv</span>
                </label>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="flex px-2 py-2 mt-12">
          <button class="block btn_default sm:w-auto sm:inline-block" @click="onDelete">
            Radera
          </button>

          <button class="block w-full btn_blue sm:w-auto sm:inline-block" :class="{ 'opacity-50': isDirty !== true || invalid }" :disabled="isDirty !== true || invalid" @click="onSave">
            Spara
          </button>
        </div>
      </div>
    </ValidationObserver>
    <DialogBase />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DialogBase from "@/components/dialogs/DialogBase.vue";
import { destroyDialog } from "@/components/dialogs/dialogs";

export default {
  name: "apigeneral",
  components: { DialogBase },
  computed: {
    ...mapGetters("apiresourcesStore", ["current", "isDirty"])
  },

  methods: {
    ...mapActions("apiresourcesStore", ["fetch", "save", "delete"]),
    async onSave() {
      await this.save();
      this.$refs.form.reset();
    },
    async onDelete() {
      const callback = async () => {
        try {
          await this.delete();
        } finally {
          this.$router.push("/apiresources");
          this.$modal.hide("dialog-base");
        }
      };
      destroyDialog(this, callback, "Api " + this.current.name);
    }
  }
};
</script>
